exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.file-browser-toggle-tooltip .tooltip-inner[data-v-216641de] {\n  max-width: 210px;\n}\n", ""]);

